import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { loadFamilyLandingRequest, loadFamilyLandingSuccess } from 'reactApp/modules/familyLanding/familyLanding.module';
import { routeChangeSuccess } from 'reactApp/modules/router/router.module';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { put, takeEvery } from 'redux-saga/effects';

function* startLandingFamily() {
    yield put(
        routeChangeSuccess({
            id: ROOT_FOLDER_ID,
            storage: EStorageType.familyLanding,
            params: {},
            __isFolder: true,
            url: '',
            __parent: '',
        })
    );

    yield put(loadFamilyLandingSuccess());
}

export function* watchFamilyLanding() {
    yield takeEvery(loadFamilyLandingRequest.toString(), startLandingFamily);
}
